(function () {
  const INTERVAL = 5000;

  function initCarouselAutoplay(carousel) {
    const nextBtn = carousel.querySelector(
      'button[name="next"], .slideshow__control--next, [aria-label*="next"], [aria-label*="Next"], [aria-label*="nächste"], [aria-label*="Nächste"], button:last-of-type'
    );
    const prevBtn = carousel.querySelector(
      'button[name="previous"], .slideshow__control--prev, [aria-label*="prev"], [aria-label*="Prev"], [aria-label*="vorige"], [aria-label*="Vorige"], button:first-of-type'
    );

    if (!nextBtn) return;

    function goNext() {
      // Prüfen ob Next-Button deaktiviert ist (= letzter Slide)
      if (nextBtn.disabled || nextBtn.getAttribute('aria-disabled') === 'true') {
        // Zum ersten Slide zurückspringen
        if (prevBtn) {
          // Mehrfach klicken um zum Anfang zu kommen
          const slides = carousel.querySelectorAll('[data-carousel-card]');
          for (let i = 0; i < slides.length; i++) prevBtn.click();
        }
      } else {
        nextBtn.click();
      }
    }

    let timer = setInterval(goNext, INTERVAL);

    carousel.addEventListener('mouseenter', () => clearInterval(timer));
    carousel.addEventListener('mouseleave', () => {
      timer = setInterval(goNext, INTERVAL);
    });

    carousel.addEventListener('touchstart', () => clearInterval(timer), { passive: true });
    carousel.addEventListener('touchend', () => {
      timer = setInterval(goNext, INTERVAL);
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('[id*="carousel_WWbUbL"] slideshow-component');
    carousels.forEach(initCarouselAutoplay);
  });
})();
